export default __webpack_public_path__ + "static/media/quadro.b2266fc8.png";